/**
 * Build /api/Hotel/search `occupancies` from TravellerModal state.
 * When `roomDetails` exists, one entry per room; otherwise split adults across `rooms`.
 */
export function buildOccupanciesFromTravelers(travelers) {
  if (!travelers) {
    return [{ numOfAdults: 1, childAges: [] }];
  }

  if (travelers.roomDetails && travelers.roomDetails.length > 0) {
    return travelers.roomDetails.map((room) => ({
      numOfAdults: room.adults,
      childAges: (room.childAges || []).filter((age) => age > 0),
    }));
  }

  const totalAdults = travelers.adults || 0;
  const numRooms = travelers.rooms || 1;
  const baseAdultsPerRoom = Math.floor(totalAdults / numRooms);
  const remainingAdults = totalAdults % numRooms;

  return Array(numRooms)
    .fill()
    .map((_, index) => ({
      numOfAdults: baseAdultsPerRoom + (index < remainingAdults ? 1 : 0),
      childAges: travelers.childAges || [],
    }));
}
